import { z } from "zod";

export const campaignValueSchema = z
    .string()
    .max(200)
    .transform((value) => value.trim())
    .transform((value) => value.replace(/[\u0000-\u001f\u007f]/gu, ""))
    .refine((value) => value.length <= 120)
    .refine((value) => !/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/iu.test(value))
    .transform((value) => value.replace(/\s+/gu, " "))
    .refine((value) => value.length > 0);

export const shortLinkCampaignSchema = z
    .object({
        utm_source: campaignValueSchema.optional(),
        utm_medium: campaignValueSchema.optional(),
        utm_campaign: campaignValueSchema.optional(),
        utm_term: campaignValueSchema.optional(),
        utm_content: campaignValueSchema.optional(),
    })
    .strict();

export const shortLinkSourceChannelSchema = z.enum([
    "direct",
    "internal",
    "search",
    "social",
    "referral",
    "unknown",
]);

export const shortLinkUnattributedReasonSchema = z.enum([
    "invalid_destination",
    "untrusted_destination",
    "existing_fragment",
    "request_id_unavailable",
]);

export const postHogDistinctIdCookieSchema = z.object({
    distinct_id: z.string().min(1),
});

export const shortLinkReferrerHostSchema = z
    .string()
    .max(253)
    .regex(
        /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/u,
    );

export const resolveShortLinkInputSchema = z
    .object({
        slug: z.string().trim().min(1).max(120),
        caseSensitive: z.boolean().default(false),
        aliasCampaign: shortLinkCampaignSchema.optional(),
        sourceReferrerHost: shortLinkReferrerHostSchema.optional(),
        sourceChannel: shortLinkSourceChannelSchema.optional(),
    })
    .strict();

export const shortLinkRedirectEventPropertiesSchema = z
    .object({
        slug: z.string(),
        destination_url: z.string(),
        redirect_request_id: z.string().optional(),
        unattributed_reason: shortLinkUnattributedReasonSchema.optional(),
        alias_campaign: shortLinkCampaignSchema.optional(),
        source_referrer_host: shortLinkReferrerHostSchema.optional(),
        source_channel: shortLinkSourceChannelSchema.optional(),
        $process_person_profile: z.literal(false).optional(),
    })
    .strict();

export const shortLinkRedirectEventSchema = z
    .object({
        api_key: z.string().min(1),
        event: z.literal("short_link_redirect"),
        distinct_id: z.string().min(1),
        properties: shortLinkRedirectEventPropertiesSchema,
    })
    .strict();

export type ShortLinkRedirectEvent = z.infer<
    typeof shortLinkRedirectEventSchema
>;
export type ShortLinkRedirectEventProperties = z.infer<
    typeof shortLinkRedirectEventPropertiesSchema
>;
